import { c as _c } from "react/compiler-runtime";
import { IcoDownload16, IcoInfo16 } from '@onefootprint/icons';
import { Button } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
type ExpandableTextProps = {
  value: string;
  maxChars?: number;
  filename?: string;
};
const ExpandableText = t0 => {
  const $ = _c(26);
  const {
    value,
    maxChars: t1,
    filename
  } = t0;
  const maxChars = t1 === undefined ? 5000 : t1;
  const {
    t
  } = useTranslation("onboarding-data-entry-viewer");
  const isTruncated = value.length > maxChars;
  let t2;
  if ($[0] !== isTruncated || $[1] !== maxChars || $[2] !== value) {
    t2 = isTruncated ? value.slice(0, maxChars) : value;
    $[0] = isTruncated;
    $[1] = maxChars;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const displayValue = t2;
  let t3;
  if ($[4] !== filename || $[5] !== value) {
    t3 = () => {
      const blob = new Blob([value], {
        type: "text/plain"
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${filename || "content"}.txt`;
      a.click();
      URL.revokeObjectURL(url);
    };
    $[4] = filename;
    $[5] = value;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleDownload = t3;
  let t4;
  if ($[7] !== isTruncated) {
    t4 = cx("p-4 text-snippet-2 text-primary whitespace-pre-wrap wrap-break-word", {
      "pb-11": isTruncated
    });
    $[7] = isTruncated;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = isTruncated && "...";
  let t6;
  if ($[9] !== displayValue || $[10] !== t4 || $[11] !== t5) {
    t6 = <div className={t4}>{displayValue}{t5}</div>;
    $[9] = displayValue;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== handleDownload || $[14] !== isTruncated || $[15] !== t) {
    t7 = isTruncated && <div className="absolute bottom-0 left-0 w-full p-2 bg-secondary rounded-b-md"><Button prefixIcon={IcoDownload16} variant="secondary" size="compact" type="button" onClick={handleDownload} className="bg-transparent! border-0! shadow-none!">{t(_temp)}</Button></div>;
    $[13] = handleDownload;
    $[14] = isTruncated;
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <div className="relative">{t6}{t7}</div>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== isTruncated || $[21] !== t) {
    t9 = isTruncated && <div className="flex items-center gap-1.5 text-caption-4 text-tertiary mt-1"><IcoInfo16 /><span>{t(_temp2)}</span></div>;
    $[20] = isTruncated;
    $[21] = t;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t8 || $[24] !== t9) {
    t10 = <div className="flex flex-col gap-2">{t8}{t9}</div>;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
export default memo(ExpandableText);
function _temp($) {
  return $.download;
}
function _temp2($_0) {
  return $_0.contentTooLarge;
}